import { appConsts } from 'src/utils/consts';

declare let abp: any;

export function L(key: string, sourceName?: string): string {
  const localizationSourceName = appConsts.localization.defaultLocalizationSourceName;
  return abp.localization.localize(key, sourceName || localizationSourceName);
}

export function isGranted(permissionName: string): boolean {
  return abp.auth.isGranted(permissionName);
}
